/**
 * Configure and register global directives
 */
import { setupLoadingDirective } from "./loading";
import { setupPermissionDirective } from "./permission";
import type { App } from "vue";

export function setupGlobDirectives(app: App) {
  setupPermissionDirective(app);
  setupLoadingDirective(app);
}
